import { createSlice } from "@reduxjs/toolkit";

export const cronSlice = createSlice({
  name: "cron",
  initialState: {
    getCronResult: false,
    getCronLoading: false,
    getCronError: false,
    addCronResult: false,
    addCronLoading: false,
    deleteCronResult: false,
  },
  reducers: {
    cronReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_CRON":
          return {
            ...state,
            getCronResult: payload.data,
            getCronLoading: payload.loading,
            getCronError: payload.error,
          };
        case "ADD_CRON":
          return {
            ...state,
            addCronResult: payload.data,
            addCronLoading: payload.loading,
          };
        case "DELETE_CRON":
          return {
            ...state,
            deleteCronResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { cronReducers } = cronSlice.actions;

export default cronSlice.reducer;
